import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { CustomErrorStateMatcher } from "@merri/common";
import { Subject, takeUntil } from "rxjs";
import { PRODUCT_NAME } from "src/app/core";
import { CustomerVenueRequestInfo } from "../../models";

interface VenueRequestPrice {
  title: string;
  subtitle: string;
  price: string;
  discount?: string;
  unrestrictedAccess: boolean;
  disabled?: boolean;
  free?: boolean;
  strikeout?: boolean;
}

@Component({
    selector: "app-venue-request-wizard-price",
    templateUrl: "./venue-request-wizard-price.component.html",
    styleUrls: ["./venue-request-wizard-price.component.scss"],
    standalone: false
})
export class VenueRequestWizardPriceComponent implements OnChanges, OnDestroy {
  private _destroyed$: Subject<void> = new Subject<void>();
  @Input() info: CustomerVenueRequestInfo;
  @Input() form: FormGroup;
  @Input() matcher: CustomErrorStateMatcher;

  prices: VenueRequestPrice[];
  freeMode: boolean;
  isPrivateResidence: boolean;

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  ngOnInit(): void {
    this.setState();

    this.form.valueChanges.pipe(takeUntil(this._destroyed$)).subscribe({
      next: () => {
        const ipr = this.form.value.isPrivateResidence == true;

        if (ipr !== this.isPrivateResidence) {
          this.isPrivateResidence = ipr;
          this.setState();
        }
      },
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.info) {
      this.setState();
    }
  }

  private setState(): void {
    this.freeMode = false;
    this.prices = undefined;

    if (!this.form) return;
    if (!this.info) return;
    if (!this.info.paidRequests) return;

    if (this.info.isFreeRequest) {
      this.prices = [
        {
          title: "First Request Free!",
          subtitle: `We will create one custom venue for free as part of your ${PRODUCT_NAME} membership. After this request, there will be a $${this.info.discountedPricePerRoom} per room fee for all custom work.`,
          price: `$${this.info.discountedPricePerRoom}/room`,
          free: true,
          unrestrictedAccess: true,
          strikeout: true,
        },
      ];

      this.freeMode = true;
    } else {
      const ipr = this.form.value.isPrivateResidence == true;

      this.prices = [
        {
          title: "Public for everyone",
          subtitle: "Venue will be available in public catalog. Great for non-private residences.",
          price: ipr ? "Unavailable" : `$${this.info.discountedPricePerRoom}/room`,
          discount: ipr ? "" : `save ${this.info.getCouponPct()}%`,
          unrestrictedAccess: true,
          disabled: ipr,
        },
        {
          title: "Private to your account",
          subtitle: "Venue will be available to your account only. Great for private residences.",
          price: `$${this.info.originalPricePerRoom}/room`,
          unrestrictedAccess: false,
        },
      ];
    }
  }
}
